import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const daysForPeriod = (institutionId: string, startDate: string, endDate: string) => {
    return RESTClient.getAuthenticatedObservable('daycare/vacation/generatepossibledays', {
        institutionId,
        startDate,
        endDate,
    });
};

export const getPossibleRecipients = (institutionId: string) => {
    return RESTClient.getAuthenticatedObservable('daycareadmin/recipients/vacation', {
        institutionId,
    });
};

export interface CreateData {
    institutionId: string;
    title: string;
    body?: string;
    deadline: string;
    recipients: string[];
    days: string[];
    askForDetailedAttendance?: boolean;
}

export const create = (data: CreateData) => {
    return RESTClient.postAuthenticatedObservable('daycare/vacation/new', data);
};
